// extracted by mini-css-extract-plugin
export default {"bump":"Alert_bump__yQgS+"};